(() => {
  'use strict';

  function publish(eventName, payload = {}) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(eventName, payload);
    }
  }

  function handleClick(event) {
    const link = event.target.closest?.('a');

    if (!link) return;

    const href = link.getAttribute('href') || '';
    const linkText = (link.textContent || '').trim();

    if (href.startsWith('tel:')) {
      publish('custom_phone_click', {
        phone_number: href.replace(/^tel:/, ''),
        link_url: href,
        link_text: linkText
      });
    }

    if (href.startsWith('mailto:')) {
      publish('custom_email_click', {
        email_address: href.replace(/^mailto:/, '').split('?')[0],
        link_url: href,
        link_text: linkText
      });
    }
  }
document.addEventListener('click', handleClick);

// =============================================================================
// LIVECHAT
// =============================================================================

function initLiveChatTracking() {
  if (
    !window.LiveChatWidget ||
    typeof window.LiveChatWidget.on !== 'function'
  ) {
    return false;
  }

  let livechatStarted = false;

  // Widget visibility
  window.LiveChatWidget.on('visibility_changed', function(data) {
    const visibility = data?.visibility || '';

    publish('custom_livechat_visibility_changed', {
      livechat_visibility: visibility
    });

    if (visibility === 'maximized') {
      publish('custom_livechat_open', {
        livechat_visibility: visibility
      });
    }
  });

  // Customer/chat status
  window.LiveChatWidget.on('customer_status_changed', function(data) {
    const status = data?.status || '';

    publish('custom_livechat_customer_status_changed', {
      livechat_status: status
    });

    if (
      status === 'chatting' &&
      !livechatStarted
    ) {
      livechatStarted = true;

      publish('custom_livechat_start', {
        livechat_status: status
      });
    }
  });

  // LiveChat events
  window.LiveChatWidget.on('new_event', function(data) {
    publish('custom_livechat_new_event', {
      livechat_event_type: data?.type || '',
      livechat_author_type: data?.author?.type || '',
      livechat_event_timestamp: data?.timestamp || ''
    });
  });

  return true;
}

if (!initLiveChatTracking()) {
  const liveChatInitInterval = setInterval(function() {
    if (initLiveChatTracking()) {
      clearInterval(liveChatInitInterval);
    }
  }, 1000);

  setTimeout(function() {
    clearInterval(liveChatInitInterval);
  }, 10000);
}

})();